import React from 'react'
import MuiLinearProgress from '@material-ui/core/LinearProgress'
import type { LinearProgressProps as MuiLinearProgressProps } from '@material-ui/core/LinearProgress'
import { makeStyles, useTheme } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import Grid from '../Grid'
import Typography from '../Typography'
import type { StyleClasses } from '../../styles'

const useStyles = makeStyles<Theme, LinearProgressProps>(
  (theme) => ({
    root: {
      position: 'relative',
      width: '100%'
    },
    progress: {
      display: 'flex',
      height: '3em',
      borderRadius: 4
    },
    label: {
      position: 'absolute',
      backgroundColor: 'transparent',
      left: 24,
      top: 17,
      fontWeight: theme.typography.fontWeightMedium
    },
    colorPrimary: {
      backgroundColor: theme.paintscout.palette?.brand?.Neutral?.P96
    },
    barColorPrimary: {
      backgroundColor: theme.paintscout.palette?.brand?.Blue?.Blue70
    }
  }),
  { name: 'LinearProgressLabel' }
)

export interface LinearProgressProps extends Omit<MuiLinearProgressProps, 'classes'> {
  classes?: StyleClasses<typeof useStyles>
  value: number
}

function LinearProgressLabel(props: LinearProgressProps) {
  const classes = useStyles(props)
  const { value } = props
  const theme = useTheme()

  const { root, progress, label, ...muiClasses } = classes

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} className={root}>
        <MuiLinearProgress {...props} value={value} classes={muiClasses} className={progress} />
        <Typography
          variant="subtitle1"
          className={label}
          weight={700}
          style={{
            color: value < 14 ? theme.palette.text.primary : theme.palette.common.white
          }}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  )
}

LinearProgressLabel.defaultProps = {
  color: 'primary' as const
}

export default LinearProgressLabel
